var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:1.5px;}")),React.createElement("circle",{"className":"cls-1","cx":"12","cy":"7.25","r":"5.73","key":1}),React.createElement("path",{"className":"cls-1","d":"M1.5,23.48l.37-2.05A10.3,10.3,0,0,1,12,13h0a10.3,10.3,0,0,1,10.13,8.45l.37,2.05","key":2})]);
}

Account.defaultProps = {"width":"26","height":"26","viewBox":"0 0 24 24","id":"Layer_1","data-name":"Layer 1"};

module.exports = Account;

Account.default = Account;
